// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"96":"vendors","869":"styles"}[chunkId] + ".css";
};